import React, { useState } from "react";
import "./updateEleve.scss";

import { Close, Person2Sharp } from "@mui/icons-material";

import _ from "lodash";

import "react-phone-input-2/lib/style.css";
// import ReactFlagsSelect from "react-flags-select";
import { IconButton } from "@mui/material";
import {
  classeType,
  EleveType,
  ParentType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../../_services/accountServices";
import { API_ELEVE } from "../../../apiCaller/eleve.Caller";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";
import axios from "axios";
import { URL_BACKEND_APP } from "../../../App.constants.js";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
  data: EleveType | undefined;
  dataParent: ParentType[];
  dataClasse: classeType[];
  currentYear: string;
  dataYear: schooYearType[];
  dispatchReload: () => void;
}
const UpdateEleve = (props: Props) => {
  let promotionId: number | undefined = undefined;

  const sortedParentData = _.orderBy(props.dataParent, ["nom"], ["asc"]);

  for (const value of props.dataClasse) {
    if (
      props.data &&
      props.data.promotionClasse &&
      value.classe_designation
        ?.toLowerCase()
        .includes(props.data?.promotionClasse.toLowerCase())
    ) {
      promotionId = value.classe_id;
    }
  }

  const [eleveData, setEleveData] = useState({
    nom: props.data?.nom,
    postnom: props.data?.postnom,
    prenom: props.data?.prenom,
    sexe: props.data?.sexe,
    dateNaissance: props.data?.date_naissance,
    ville: props.data?.ville,
    commune: props.data?.commune,
    quartier: props.data?.quartier,
    avenue: props.data?.avenue,
    classDesignation: props.data?.classe_designation,
    classId: promotionId,
  });

  const [parentId, setParentId] = useState<string | number | undefined>(
    props.data?.parent_id
  );

  const [classeDesignationId, setClasseDesignationId] = useState<
    string | number | undefined
  >(eleveData.classId);

  // console.log(classeDesignationId);

  let handleChange = (e) => {
    setEleveData({ ...eleveData, [e.target.name]: e.target.value });
  };

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  let yearId: number | string | undefined;
  for (const value of props.dataYear) {
    if (
      props.currentYear &&
      value.annee_scolaire_designation
        .toLowerCase()
        .includes(props.currentYear.toLowerCase())
    ) {
      yearId = value.annee_scolaire_id;
    }
  }

  let dataForClasse = {
    nom: eleveData.nom,
    postnom: eleveData.postnom,
    prenom: eleveData.prenom,
    sexe: eleveData.sexe,
    ville: eleveData.ville,
    commune: eleveData.commune,
    quartier: eleveData.quartier,
    avenue: eleveData.avenue,
    date_naissance: eleveData.dateNaissance,
    parent_id: parentId,
  };

  let dataForPromotion = {
    // eleve_id: props.data?.eleve_id,
    // id: props.data?.promotionId,
    classe_id: classeDesignationId,
    annee_scolaire_id: yearId,
  };

  const handleUpdateEleve = async () => {
    if (
      !eleveData.nom?.toString().length ||
      !eleveData.postnom?.toString().length ||
      !eleveData.prenom?.toString().length ||
      !eleveData.ville?.toString().length ||
      !eleveData.commune?.toString().length ||
      !eleveData.quartier?.toString().length ||
      !eleveData.avenue?.toString().length
    ) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    try {
      const response = await API_ELEVE.ELEVE.update(
        props.data?.eleve_id,
        dataForClasse,
        token
      );
      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
        // setEleveData({...eleveData})
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };
  const handleUpdateEleveAndPromotion = async () => {
    if (
      !eleveData.nom?.toString().length ||
      !eleveData.postnom?.toString().length ||
      !eleveData.prenom?.toString().length ||
      !eleveData.ville?.toString().length ||
      !eleveData.commune?.toString().length ||
      !eleveData.quartier?.toString().length ||
      !eleveData.avenue?.toString().length
    ) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    try {
      const [res1, res2] = await API_ELEVE.PROMOTION.updateElevePromotion(
        props.data?.eleve_id,
        props.data?.promotionId,
        dataForClasse,
        dataForPromotion,
        token
      );

      console.log(res1);
      console.log(res2);

      if (res1.data.status === 200) {
        toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
        // setEleveData({...eleveData})
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      console.log(error);
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  const handleUpdateEleveClasse = async () => {
    if (
      !eleveData.nom?.toString().length ||
      !eleveData.postnom?.toString().length ||
      !eleveData.prenom?.toString().length ||
      !eleveData.ville?.toString().length ||
      !eleveData.commune?.toString().length ||
      !eleveData.quartier?.toString().length ||
      !eleveData.avenue?.toString().length
    ) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    const updateRqst1 = axios.put(
      `${URL_BACKEND_APP}/eleve/update.php?id=${props.data?.eleve_id}`,
      dataForClasse,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const updateRqst2 = axios.put(
      `${URL_BACKEND_APP}/promotion/update.php?id=${props.data?.eleve_id}`,
      dataForPromotion,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    try {
      const [res1, res2] = await axios.all([updateRqst1, updateRqst2]);

      console.log(res1);
      console.log(res2);

      toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
      props.setOpen(false);
      props.dispatchReload();

      // if (response.data.status === 200) {
      //   toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
      //   // setEleveData({...eleveData})
      //   props.setOpen(false);
      //   props.dispatchReload();
      // } else {
      //   toast.error("Une erreur s'est produite, réesayez plus tard", {
      //     style: {
      //       backgroundColor: "#630f0f", // Custom background color
      //       color: "white", // Text color
      //       fontSize: "12px", // Font size
      //       zIndex: 9999,
      //     },
      //   });
      // }
    } catch (err) {
      console.log(err);
      catchErrorApiCall(err);
    } finally {
      setState({ ...state, isLoading: false });
    }
  };
  // const validatePhoneNumber = (phoneNumber: any) => {
  //   const phoneNumberPattern =
  //     /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  //   return phoneNumberPattern.test(phoneNumber);
  // };

  //phone number state
  // const [phoneNumber, setPhoneNumber] = useState("");

  // const [selectedCountry, setSelectedCountry] = useState<string>("CD");
  return (
    <div className="UpdateEleve">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <Person2Sharp className="ico" />
              <span>Modification</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}
          <div className="item">
            <label>Nom *</label>
            <input
              placeholder="Nom..."
              type="text"
              name="nom"
              value={eleveData.nom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Post-nom *</label>
            <input
              placeholder="Post-nom..."
              type="text"
              name="postnom"
              value={eleveData.postnom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Prénom *</label>
            <input
              placeholder="Prénom..."
              type="text"
              name="prenom"
              value={eleveData.prenom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Genre</label>
            <select onChange={handleChange} name="sexe" value={eleveData.sexe}>
              <option value="M">Masculin</option>
              <option value="F">Feminin</option>
            </select>
          </div>

          <div className="item">
            <label>Date naissance *</label>
            <input
              placeholder="Date de Naissance.toUpperCase()..."
              type="date"
              name="dateNaissance"
              value={eleveData.dateNaissance}
              onChange={handleChange}
            />
          </div>
          {props.data?.promotionId && yearId ? (
            <div className="item">
              <label>Classe</label>
              <select
                onChange={(e) => setClasseDesignationId(e.target.value)}
                value={classeDesignationId}
              >
                {/* <option value="">-- Selectionner promotion --</option> */}

                {props.dataClasse.map((item, index) => {
                  return (
                    <option key={index} value={item.classe_id}>
                      {item.classe_designation.toUpperCase()}
                    </option>
                  );
                })}
              </select>
            </div>
          ) : null}

          {/* <div className="item country">
            <label>Pays</label>
            <ReactFlagsSelect
              selected={selectedCountry}
              onSelect={(code) => setSelectedCountry(code)}
              optionsSize={13}
              selectedSize={13}
              searchPlaceholder="Chercher pays"
              placeholder="Choix du pays"
              searchable
              className="menu-flags"
              selectButtonClassName="menu-flags-button"
            />
          </div> */}

          <div className="item">
            <label>Ville *</label>
            <input
              placeholder="Ville..."
              type="text"
              name="ville"
              value={eleveData.ville?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Commune *</label>
            <input
              placeholder="Commune..."
              type="text"
              name="commune"
              value={eleveData.commune?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Quartier *</label>
            <input
              placeholder="Quartier..."
              type="text"
              name="quartier"
              value={eleveData.quartier?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Avenue *</label>
            <input
              placeholder="Avenue..."
              type="text"
              name="avenue"
              value={eleveData.avenue?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item tuteur">
            <label>Identité du tuteur*</label>
            <select
              name="annee_existence"
              value={parentId}
              onChange={(e) => setParentId(e.target.value)}
            >
              {sortedParentData.map((item, index) => {
                return (
                  <option
                    key={index}
                    value={item.parent_id}
                  >{`${item.nom.toUpperCase()} ${item.postnom.toUpperCase()} ${item.prenom.toUpperCase()}`}</option>
                );
              })}
            </select>
          </div>
          {/* {props.data?.promotion && props.currentYear && (
            <div className="item class">
              <label>Classe*</label>
              <select
                name="classId"
                value={eleveData.classId}
                onChange={handleChange}
              >
                {props.dataClasse.map((item, index) => {
                  return (
                    <option key={index} value={item.classe_id}>
                      {item.classe_designation.toUpperCase()}
                    </option>
                  );
                })}
              </select>
            </div>
          )} */}
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button
              onClick={
                props.data?.promotionId && yearId
                  ? handleUpdateEleveAndPromotion
                  : handleUpdateEleve
              }
            >
              Mettre à jour
            </button>
          )}
        </div>
        {/* <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : eleveData.classId && props.currentYear && yearId ? (
            <button onClick={handleUpdateEleveClasse}>Mettre à jour1</button>
          ) : (
            <button onClick={handleUpdateEleve}>Mettre à jour2</button>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default UpdateEleve;
